module.exports = __webpack_public_path__ + "static/media/VP_2_GRAPHIC.21a29cd1.svg";